import { buildBaseCommerceAPIRequest, } from './base-commerce-api-request-builder.js';
export const buildPaginatedCommerceAPIRequest = (state, navigatorContext, slotId) => {
    return {
        ...buildBaseCommerceAPIRequest(state, navigatorContext),
        ...effectivePagination(state, slotId),
    };
};
const effectivePagination = (state, slotId) => {
    const effectiveSlice = slotId
        ? state.commercePagination?.recommendations[slotId]
        : state.commercePagination?.principal;
    return (effectiveSlice && {
        page: effectiveSlice.page,
        ...(effectiveSlice.perPage && {
            perPage: effectiveSlice.perPage,
        }),
    });
};
